import popupError from '../../assets/Popups/popup-error.svg'

export const API_ERROR_DESCRIPTION =
  "We're sorry, but it seems there was an issue connecting to our server. Please check your internet connection or try refreshing the page. If the problem persists, try again later."

const ApiErrorState = ({
  title = "We're sorry",
  eyebrow = 'Error',
  description = API_ERROR_DESCRIPTION,
  children,
  className = '',
}) => {
  return (
    <div className={`fabits-api-error-state ${className}`} role='alert'>
      <div className='fabits-api-error-hero'>
        <img
          className='fabits-api-error-graphic'
          src={popupError}
          alt=''
          aria-hidden='true'
          draggable='false'
        />
        <p className='fabits-api-error-eyebrow'>{eyebrow}</p>
        <h3 className='fabits-api-error-title'>{title}</h3>
      </div>
      <div className='fabits-api-error-content'>
        <p className='fabits-api-error-description'>{description}</p>
        {children}
      </div>
    </div>
  )
}

export default ApiErrorState
